import { ChevronIcon } from "@/components/icons";
import Link from "next/link";

export const LinkTitle = ({title, href}: {title: string, href: string}) => {
    return (
        <div className="text-sm ">
            <Link className="flex items-center mb-2" href={href}>
                {title}
                <div className="ml-2">
                    <ChevronIcon />
                </div>
            </Link>
        </div>
    );
}